export class PaymentTemplateService {
    static $inject = ['$http', 'MESSAGINGHUBDOMAIN'];
    constructor($http, MESSAGINGHUBDOMAIN) {
        'ngInject';
        this.$http = $http;
        this.MESSAGINGHUBDOMAIN = MESSAGINGHUBDOMAIN;
    }
    /**
     * Converte os dados capturados pelo componente de pagamento em um template de mensagem order
     */
    generateOrderTemplate(paymentData) {
        const { information = {}, configuration = {}, customize = {}, paymentMethod = {}, } = paymentData;
        // Processa configuração de itens
        let items = [];
        try {
            if (configuration.items) {
                const parsedItems = typeof configuration.items === 'string'
                    ? JSON.parse(configuration.items)
                    : configuration.items;
                items = parsedItems.map((item, index) => ({
                    retailer_id: item.retailer_id || `item_${index}`,
                    name: item.name || 'Produto',
                    amount: {
                        value: parseInt(item.value) * 100 || 0, // Converte para centavos
                        offset: 100,
                    },
                    quantity: parseInt(item.quantity) || 1,
                }));
            }
        }
        catch (e) {
            console.warn('Erro ao processar itens:', e);
            items = [{
                    retailer_id: 'item_1',
                    name: 'Produto padrão',
                    amount: { value: 0, offset: 100 },
                    quantity: 1,
                }];
        }
        // Processa configurações de pagamento
        const paymentConfigurations = [];
        if (paymentMethod.method1?.type) {
            paymentConfigurations.push(this.createPaymentConfig(paymentMethod.method1));
        }
        if (paymentMethod.showMethod2 && paymentMethod.method2?.type) {
            paymentConfigurations.push(this.createPaymentConfig(paymentMethod.method2));
        }
        const orderDetails = {
            reference_id: `order_${Date.now()}`,
            type: configuration.productType === 'digital' ? 'digital' : 'physical',
            payment_settings: {
                type: configuration.productType === 'digital' ? 'digital_goods' : 'physical_goods',
                payment_configuration: paymentConfigurations,
            },
            order: {
                status: 'pending',
                text: customize.textBody || 'Detalhes do pedido',
                items,
            },
        };
        return {
            type: 'template',
            template: {
                namespace: 'your_namespace', // Deve ser configurado
                name: 'payment_template', // Deve ser configurado
                language: {
                    policy: 'deterministic',
                    code: 'pt_BR',
                },
                components: this.buildComponents(customize),
            },
        };
    }
    createPaymentConfig(method) {
        const config = {
            type: this.mapPaymentType(method.type),
            partial_payment_disabled: false,
            is_test_payment: true, // Sempre teste inicialmente
        };
        switch (method.type) {
            case 'pixcopycode':
                config.pix_config = {
                    code: method.config.pixCode || '',
                    merchant_name: method.config.business || '',
                    key_type: method.config.keyType?.toUpperCase() || 'CPF',
                    key: method.config.pixCode || '',
                };
                break;
            case 'barcode':
                config.boleto_config = {
                    code: method.config.boletoCode || '',
                };
                break;
            case 'paymentlink':
                config.payment_link_config = {
                    link: method.config.httpsLink || '',
                };
                break;
        }
        return config;
    }
    buildComponents(customize) {
        const components = [
            {
                type: 'header',
                format: 'text',
                text: 'Detalhes do Pagamento',
            },
            {
                type: 'body',
                text: customize.textBody || 'Aqui estão os detalhes do seu pedido:',
            },
            {
                type: 'buttons',
                buttons: [{
                        type: 'order_details',
                        text: 'Ver Detalhes',
                    }],
            },
        ];
        if (customize.textFooter) {
            components.push({
                type: 'footer',
                text: customize.textFooter,
            });
        }
        return components;
    }
    mapPaymentType(type) {
        const typeMap = {
            'pixcopycode': 'pix',
            'barcode': 'barcode',
            'paymentlink': 'payment_link',
        };
        return typeMap[type] || type;
    }
    /**
     * Salva o template de pagamento como uma ação no estado
     */
    async savePaymentTemplate(paymentData) {
        const template = this.generateOrderTemplate(paymentData);
        return {
            type: 'SendMessage',
            settings: {
                id: `payment_${Date.now()}`,
                to: '{{input.message.from}}',
                type: 'application/json',
                content: template,
            },
        };
    }
}
PaymentTemplateService.$inject = ['$http', 'MESSAGINGHUBDOMAIN'];
